const revealTemplates = new Set(['index']);
const main = document.getElementById('MainContent');
const templateName = main?.dataset.template?.split('.')[0];

if (main && revealTemplates.has(templateName) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observed = new WeakSet();
  const visibleAttribute = 'data-scroll-reveal-visible';

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        entry.target.setAttribute(visibleAttribute, 'true');
        observer.unobserve(entry.target);
      }
    },
    {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12,
    }
  );

  const getRevealType = (element) => {
    if (element.matches('.product-media-container, .resource-list__item')) return 'scale';
    return 'fade';
  };

  const getStaggerOrder = (element) => {
    const parent = element.closest('.resource-list, .product-details, media-gallery');
    if (!parent) return 0;

    return Math.max(Array.from(parent.children).indexOf(element), 0) % 8;
  };

  const isRevealCandidate = (element) => {
    if (!(element instanceof HTMLElement)) return false;
    if (element.hasAttribute('hidden') || element.closest('[hidden]')) return false;
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  const collectRevealElements = () => {
    const sections = Array.from(main.children).filter((element, index) => {
      if (!element.classList.contains('shopify-section')) return false;
      return !(templateName === 'index' && index === 0);
    });
    const innerElements = Array.from(
      main.querySelectorAll(
        [
          '.section-resource-list__header',
          '.resource-list__item',
          '.product-media-container',
          '.product-details > *',
        ].join(',')
      )
    );

    return [...sections, ...innerElements].filter(isRevealCandidate);
  };

  const registerRevealElements = () => {
    for (const element of collectRevealElements()) {
      if (observed.has(element)) continue;

      observed.add(element);
      element.setAttribute('data-scroll-reveal', getRevealType(element));
      element.style.setProperty('--scroll-reveal-order', getStaggerOrder(element));
      observer.observe(element);
    }
  };

  registerRevealElements();
  document.body.classList.add('scroll-reveal-enabled');

  const mutationObserver = new MutationObserver(() => {
    window.requestAnimationFrame(registerRevealElements);
  });

  mutationObserver.observe(main, {
    childList: true,
    subtree: true,
  });
}
